"use client";
import React from "react";
import Button from "../../../../shared/components/ui/Button";
import { useUsers } from "../../../users/hooks/useUsers";
import { CaUserAcademy } from "../../../../types/dto/program";
import StudentForm from "../../../academyProgramDetail/ui/programStudents/StudentForm";
import useUpdateStudents from "../../../academyProgramDetail/hooks/students/useUpdateStudents";
import { message } from "antd";

export interface UpdateStudentProps {
  studentId: number;
  onSuccess?: (student: CaUserAcademy) => void;
}

export default function UpdateStudent({ onSuccess, studentId }: UpdateStudentProps) {
  const [student, setStudent] = React.useState<CaUserAcademy>();
  const { findUserById } = useUsers();

  React.useEffect(() => {
    const fetch = async () => {
      await findUserById(studentId).then((it) => setStudent(it));
    };
    fetch();
  }, [studentId]);

  const { control, loading, handleSubmit } = useUpdateStudents({
    student: student!,
    onSuccess(data) {
      message.success("Datos del estudiante actualizados");
      onSuccess?.(data);
    },
  });

  if (!student) {
    return null;
  }

  return (
    <form onSubmit={handleSubmit}>
      <StudentForm control={control} />
      <div className="mt-4 flex items-center justify-end">
        <Button primary className="bg-[#072082]" loading={loading} type="submit" variant="filled">
          <i className="fa-regular fa-floppy-disk" /> Actualizar
        </Button>
      </div>
    </form>
  );
}
